// @spec DHB-STR-018
// Documents route - view and manage uploaded documents

import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@/features/datahub/uploads/DocumentsPage';

export const Route = createFileRoute('/_authenticated/datahub/documents')({
  component: DocumentsPage,
});
